import React from 'react';

const Footer = () => (
  <footer className="footer">
    <p className="footer-text">
      Created with 💖 by Henry and Victor at Microverse Inc., US.
    </p>
  </footer>
);

export default Footer;
